module.exports = __webpack_public_path__ + "assets/-_3.b487afee.svg";